<mat-checkbox class="mat-option" [indeterminate]="isIndeterminate()" [checked]="isChecked()"
    (change)="toggleSelection($event)">
    {{text}}
</mat-checkbox>
